import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const EmptyBetslipIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="70" height="70" opacity="0.7" viewBox="0 0 512 460.8">
		<g transform="translate(-1.75 1)">
			<g transform="translate(1.75 -1)">
				<path
					d="M492.8,268.2a37.784,37.784,0,1,1,0-75.566,19.292,19.292,0,0,0,13.568-5.555A18.959,18.959,0,0,0,512,173.605l-.026-68.539C511.974,47.13,464.384,0,405.914,0H106.086C47.616,0,.026,47.13.026,105.066L0,175.812a18.959,18.959,0,0,0,5.632,13.469A19.292,19.292,0,0,0,19.2,194.837c21.734,0,38.118,15.3,38.118,35.589A37.99,37.99,0,0,1,19.2,268.2,19.12,19.12,0,0,0,0,287.22v68.488C0,413.645,47.565,460.8,106.061,460.8H405.939C464.435,460.8,512,413.645,512,355.708V287.22A19.12,19.12,0,0,0,492.8,268.2"
					fill="#9dd9db"
				/>
				<path
					d="M181.4,86.733l-30.182,29.389,7.142,41.549a18.962,18.962,0,0,1-27.546,19.942L93.571,158.029l-37.325,19.61A18.911,18.911,0,0,1,28.8,157.67l7.117-41.549L5.737,86.733A18.926,18.926,0,0,1,16.31,54.426l41.626-6.067L76.6,10.547A18.9,18.9,0,0,1,93.571,0h.051a18.849,18.849,0,0,1,16.947,10.573l18.662,37.786,41.7,6.093A18.916,18.916,0,0,1,181.4,86.733"
					transform="translate(162.417 133.135)"
					fill="#114f51"
				/>
			</g>
		</g>
	</svg>
);
